import { useRef } from "react";
import TopPageMenu from "../../components/TopPageMenu";
import TopPageBgAnim from "../../components/TopPageBgAnim";
import logo from "../../img/top/title_logo.png";
import top_illust from "../../img/top/logo.png";
import "./TopPage.scoped.scss";
import Staff from "../../components/Staff";
import LoadScreen from "../../components/LoadScreen";

interface Props {}

export default function TopPage(props: Props) {
  const refLogo = useRef<HTMLImageElement>(null);

  // 再レンダリングを行わずにステートを共有したいので面倒なことをしています。
  const shareState = {
    active: false,
  };

  return (
    <div className="top-contents">
      <TopPageBgAnim shareState={shareState}></TopPageBgAnim>
      <div className="logo-space">
        <img
          src={logo}
          className="top-logo"
          alt="Aki-kun's birthday festival 2021"
          ref={refLogo}
        />
      </div>
      <p className="w-auto py-5 text-sm md:text-base rounded-3xl description">
        このサイトは、にじさんじ所属ライバー元1期生&ensp;
        <br className="md:hidden" />
        鈴谷アキくんの誕生日を祝して
        <br />
        有志により制作された非公式ファンサイトです。
      </p>
      <div className="top-main">
        <div className="top-illust">
          <img
            src={top_illust}
            className="top-illust-img"
            alt="illustration by Blank"
          />
        </div>
        <div className="buttons">
          <TopPageMenu></TopPageMenu>
        </div>
      </div>
      <p className="w-auto px-10 text-4xl text-transparent">Akikun Suki</p>
      <Staff></Staff>
      <LoadScreen
        onCompleted={() => {
          setTimeout(() => {
            if (refLogo.current) {
              const style = refLogo.current.style;
              style.animationPlayState = "running";
            }
            shareState.active = true;
          }, 500);
        }}
      ></LoadScreen>
    </div>
  );
}
